import React from 'react';

import Product from './Product';

const ProductsList = props => {
  const { goods } = props;

  return goods.map(good => <Product key={good.id} good={good} />);
};

export default ProductsList;
